import React, { useState } from "react";
import {
    Stepper,
    Step,
    StepLabel,
    Button,
    Typography,
    Paper,
    Box,
    Grid
} from "@material-ui/core";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import TableChartIcon from "@material-ui/icons/TableChart";
import WarningIcon from "@material-ui/icons/Warning";
import SharedTitle from "./SharedForms/SharedTitle";
import { downloadEquipMasivoXls, getGuiaCodigosEquipamiento, getGuiaCodigosEquipamientoXlsx, subirCargaMasivaEquipFt } from "services/api";
import { toast, CustomToast } from '@jumbo/components/custom/Toast';
import Spinner from "@jumbo/components/custom/Spinner";
import { useRef } from "react";

function getSteps() {
    return [
        "Consultar Guía y Códigos",
        "Preparar Plantilla",
        "Cargar Equipamiento"
    ];
}

export default function StepperCarga() {
    const [activeStep, setActiveStep] = React.useState(0);
    const [archivo, setArchivo] = React.useState(null);
    const [loading, setIsLoading] = useState(false)
    const [reload, setReload] = useState(false)
    const [exitos, setExitos] = useState([])
    const [fallos, setFallos] = useState([])
    const fileInputRef = useRef(null);

    const steps = getSteps();

    const handleNext = () => {
        setActiveStep(prev => prev + 1);
    };

    const handleBack = () => {
        setActiveStep(prev => prev - 1);
    };


    const descargarPlantilla = () => {
        downloadEquipMasivoXls()
            .then(res => {
                const blob = new Blob([res.data]);
                const downloadUrl = URL.createObjectURL(blob);
                const filename = 'carga_masiva_equipamiento_fichas_tecnicas.xlsx';
                const anchor = document.createElement('a');
                anchor.href = downloadUrl;
                anchor.download = filename;
                document.body.appendChild(anchor);
                anchor.click();
                anchor.remove();
                URL.revokeObjectURL(downloadUrl);
            })
            .catch(e => console.error(e))
            .finally(f => {

            })
    }

    const postCargaMasivaEq = (data) => {
        setIsLoading(true);

        subirCargaMasivaEquipFt(data, sessionStorage.getItem("idFicha"))
            .then((res) => {
                const parsed = res.data;

                const paraExitos = [{
                    "total": parsed.total_filas,
                    "cargados": parsed.registros_creados,
                }]

                setExitos(paraExitos)
                if (parsed.registros_fallidos > 0) {
                    toast.warn(`Carga completa con advertencias: ${parsed.registros_fallidos} fallos`);

                    // Aquí tienes el json para mostrar en pantalla
                    setFallos(parsed.errores)

                    // Si además quieres descargar el txt
                    if (parsed.archivo_error?.content) {
                        const blob = new Blob([parsed.archivo_error.content], {
                            type: "text/plain;charset=utf-8"
                        });

                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.href = url;
                        a.download = parsed.archivo_error.filename || "errores_carga.txt";
                        document.body.appendChild(a);
                        a.click();
                        a.remove();
                        window.URL.revokeObjectURL(url);
                    }
                } else {
                    toast.success("Archivo subido correctamente.");
                }
            })
            .catch((e) => {
                toast.error("Error cargando archivo.");
                console.error(e);
            })
            .finally(() => {
                setIsLoading(false);
                setReload(!reload);
                setArchivo(null)
                if (fileInputRef.current) {
                    fileInputRef.current.value = ""
                }
            });
    };

    const changeSingleFile = e => {

        let auxFile = e.target.files[0];
        //    const fileMb = auxFile.size / 1024 ** 2;

        if (auxFile.name === 'carga_masiva_equipamiento_fichas_tecnicas.xlsx') {
            setArchivo(auxFile)

        } else {
            toast.error('El archivo debe ser "carga_masiva_equipamiento_fichas_tecnicas.xlsx".');
        }

    };

    const getStepContent = step => {
        switch (step) {
            case 0:
                return (
                    <Box
                        style={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                            minHeight: 373
                        }}
                    >
                        <Typography variant="h3" style={{ fontWeight: 600, marginBottom: 10 }}>
                            Paso 1: Consulte la guía y tabla de códigos
                        </Typography>
                        <Typography variant="h5" style={{ fontWeight: 400 }}>
                            Antes de realizar la carga, revise la guía de categorización de equipos, con el fin
                            de conocer las categorías disponibles y los datos asociados a cada una de ellas.
                        </Typography>
                        <Grid container spacing={2} style={{ marginTop: 16 }} direction="column">
                            <Grid item xs={12} md={3}>
                                <Button
                                    fullWidth
                                    variant="outlined"
                                    color="primary"
                                    startIcon={<PictureAsPdfIcon />}
                                    style={{
                                        justifyContent: "flex-start"
                                    }}
                                    onClick={() => {
                                        getGuiaCodigosEquipamiento()
                                            .then((response) => {
                                                const blob = new Blob([response.data], { type: 'application/pdf' });
                                                const url = window.URL.createObjectURL(blob);

                                                const link = document.createElement('a');
                                                link.href = url;
                                                link.download = 'GUIA_DE_CODIGOS_EQUIPAMIENTO.pdf';

                                                document.body.appendChild(link);
                                                link.click();
                                                link.remove();

                                                window.URL.revokeObjectURL(url);
                                            })
                                            .catch((error) => {
                                                console.error('Error al descargar la guía:', error);
                                            });
                                    }}
                                >
                                    GUÍA DE CÓDIGOS (PDF)
                                </Button>
                            </Grid>

                            <Grid item xs={12} md={3}>
                                <Button
                                    fullWidth
                                    variant="outlined"
                                    startIcon={<TableChartIcon />}
                                    style={{
                                        backgroundColor: "white",
                                        color: "#2e7d32",
                                        justifyContent: "flex-start"
                                    }}
                                    onClick={() => {
                                        getGuiaCodigosEquipamientoXlsx()
                                            .then((response) => {
                                                const blob = new Blob([response.data], { type: 'application/xlsx' });
                                                const url = window.URL.createObjectURL(blob);

                                                const link = document.createElement('a');
                                                link.href = url;
                                                link.download = 'CODIGOS_DE_EQUIPOS.xlsx';

                                                document.body.appendChild(link);
                                                link.click();
                                                link.remove();

                                                window.URL.revokeObjectURL(url);
                                            })
                                            .catch((error) => {
                                                console.error('Error al descargar la guía:', error);
                                            });
                                    }}
                                >
                                    CÓDIGOS DE EQUIPOS (EXCEL)
                                </Button>
                            </Grid>
                        </Grid>
                        <Typography variant="h5" style={{ fontWeight: 400, marginBottom: 20, marginTop: 20 }}>
                            Descargue ambos recursos para asegurar una carga exitosa.
                        </Typography>
                    </Box>
                );

            case 1:
                return (
                    <Box
                        style={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                            minHeight: 373
                        }}
                    >
                        <Typography variant="h3" style={{ fontWeight: 600, marginBottom: 10 }}>
                            Paso 2: Descargue y complete la plantilla excel oficial
                        </Typography>
                        <Typography variant="h5" style={{ fontWeight: 400 }}>
                            Complete la información respetando el formato establecido, sin modificar las
                            cabeceras, utilice únicamente los códigos válidos definidos en el Paso 1 para
                            asegurar la correcta carga de los datos.
                        </Typography>
                        <Grid container spacing={2} style={{ marginTop: 16 }} >
                            <Grid item xs={12} md={3}>
                                <Button
                                    fullWidth
                                    startIcon={<TableChartIcon />}
                                    variant="outlined"
                                    style={{
                                        backgroundColor: "white",
                                        color: "#2e7d32",
                                        justifyContent: "flex-start"
                                    }}
                                    onClick={() => { descargarPlantilla() }}
                                >
                                    DESCARGAR PLANTILLA
                                </Button>
                            </Grid>
                        </Grid>

                        <Grid
                            container
                            spacing={3}
                            alignItems="center"
                            style={{
                                flex: 1,
                                height: "100%"
                            }}
                        >
                            <Grid item xs={12} md={6}>
                                <Box
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}
                                >
                                    <img
                                        src="/images/super/ft-equipamiento/excelequipamiento.PNG"
                                        alt="Vista previa plantilla Excel"
                                        style={{
                                            maxWidth: "100%",
                                            maxHeight: "260px",
                                            objectFit: "contain",
                                            border: "1px solid #dcdcdc",
                                            borderRadius: 4,
                                            padding: 5
                                        }}
                                    />
                                </Box>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                {/*                                 <Box
                                    style={{
                                        height: "100%",
                                        display: "flex",
                                        alignItems: "center"
                                    }}
                                >
                                    <ol
                                        style={{
                                            margin: 0,
                                            paddingLeft: 24,
                                            fontSize: 28,
                                            fontWeight: 500,
                                            lineHeight: 1.6
                                        }}
                                    >
                                        <li>Use esta plantilla.</li>
                                        <li>No modifique cabeceras.</li>
                                        <li>Use códigos válidos del Paso 1.</li>
                                    </ol>
                                </Box> */}
                            </Grid>
                        </Grid>
                    </Box>
                );

            case 2:
                return (
                    <>
                        <Typography
                            variant="h3"
                            style={{ fontWeight: 600, marginBottom: 10 }}
                        >
                            Paso 3: Cargue su archivo y valide los resultados
                        </Typography>

                        <Paper
                            variant="outlined"
                            style={{
                                padding: 10,
                                border: "2px dashed #4a4a4a",
                                borderRadius: 12,
                                textAlign: "center",
                                backgroundColor: "#fafafa",
                                marginBottom: 24,
                                height: 150
                            }}
                        >
                            <CloudUploadIcon
                                style={{
                                    fontSize: 44,
                                    color: "#1f2a60",
                                    marginBottom: 5
                                }}
                            />

                            <Typography
                                variant="h6"
                                style={{ marginBottom: 12 }}
                            >
                                Arrastre su Archivo Excel Aquí o
                            </Typography>

                            <input
                                accept=".xls,.xlsx"
                                style={{ display: "none" }}
                                id="archivo-excel"
                                type="file"
                                ref={fileInputRef}
                                onChange={e => changeSingleFile(e)}
                            />

                            <label htmlFor="archivo-excel">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    component="span"
                                >
                                    SELECCIONAR ARCHIVO
                                </Button>
                            </label>

                            {archivo && (
                                <Typography
                                    style={{
                                        marginTop: 12,
                                        fontWeight: 500
                                    }}
                                >
                                    Archivo seleccionado: {archivo.name}
                                </Typography>
                            )}
                        </Paper>

                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                {
                                    exitos.length ?
                                        <Paper
                                            elevation={0}
                                            style={{
                                                padding: 20,
                                                backgroundColor: "#eef8ee",
                                                border: "1px solid #d6ead6",
                                                borderRadius: 8,
                                                minHeight: 160

                                            }}
                                        >
                                            <Typography
                                                variant="h6"
                                                style={{ fontWeight: 700, marginBottom: 16 }}
                                            >
                                                {
                                                    "Total Registros en documento: " + exitos[0].total
                                                }
                                            </Typography>

                                            <Box display="flex" alignItems="center" mb={1.5}>
                                                <CheckCircleIcon
                                                    style={{
                                                        color: "#2e7d32",
                                                        marginRight: 8
                                                    }}
                                                />
                                                <Typography>
                                                    {
                                                        "Registros cargados: " + exitos[0].cargados
                                                    }
                                                </Typography>
                                            </Box>

                                            {/*                                             <Box display="flex" alignItems="center">
                                                <CheckCircleIcon
                                                    style={{
                                                        color: "#2e7d32",
                                                        marginRight: 8
                                                    }}
                                                />
                                               <Typography>9 Equipos Cargados</Typography>
                                            </Box> */}
                                        </Paper>

                                        :

                                        null
                                }
                            </Grid>

                            <Grid item xs={12} md={6}>
                                {
                                    fallos.length ?
                                        <Paper
                                            elevation={0}
                                            style={{
                                                padding: 20,
                                                backgroundColor: "#fff8e8",
                                                border: "1px solid #f0dfb2",
                                                borderRadius: 8,
                                                minHeight: 160

                                            }}
                                        >
                                            <Typography
                                                variant="h6"
                                                style={{ fontWeight: 700, marginBottom: 16 }}
                                            >
                                                {"Registros fallidos:" + fallos.length}
                                            </Typography>

                                            {fallos.map((item, index) => {
                                                return (
                                                    <Box display="flex" alignItems="center" mb={1.5} key={index}>
                                                        <WarningIcon
                                                            style={{
                                                                color: "#d4a017",
                                                                marginRight: 8
                                                            }}
                                                        />
                                                        {item.motivo.map((mot, ind) => {
                                                            return (
                                                                <Typography key={"" + ind + index}>{mot}</Typography>
                                                            )
                                                        })}
                                                    </Box>
                                                )
                                            })}

                                        </Paper>
                                        :
                                        null
                                }
                            </Grid>
                        </Grid>

                    </>
                );

            default:
                return "Paso desconocido";
        }
    };

    return (
        <div style={{ width: "100%", flexBasis: "100%", backgroundColor: "white" }}>
            <CustomToast />
            {loading ?
                <Spinner show={loading} />
                :
                null
            }
            <SharedTitle title={"Carga masiva de equipamiento"} />

            <Grid
                item
                xs={12}
                sm={12}
                md={12}
                style={{
                    paddingTop: 15,
                    paddingBottom: 15,
                    paddingRight: 25,
                    paddingLeft: 25
                }}
            >
                {/*  <p>{DESC_CARGA_EQUIPAMIENTO}</p> */}
                <p style={{ textAlign: 'justify' }}>
                    En este módulo se permite la carga de equipamiento mediante una plantilla de Excel,
                    para ello, los equipos deben ser registrados en la planilla utilizando las categorías
                    y códigos definidos en el Paso 1. Durante el proceso, los datos ingresados serán
                    sometidos a validaciones, permitiendo identificar coincidencias e inconsistencias
                    en la información. En caso de existir observaciones, el sistema generará advertencias
                    para que estas puedan ser revisadas y completadas. Cabe destacar que los equipos que
                    no cuenten con códigos también serán cargados en el sistema, quedando con información
                    incompleta y debiendo ser posteriormente regularizados.
                </p>

            </Grid>

            <Grid
                container
                direction="column"
                style={{
                    flex: 1,
                    paddingLeft: 24,
                    paddingRight: 24,
                    paddingBottom: 24
                }}
            >
                <Grid
                    item
                    style={{
                        flex: 1,
                        minHeight: 0
                    }}
                >
                    <Paper
                        elevation={0}
                        style={{
                            paddingLeft: 24,
                            paddingRight: 24,
                            height: "100%",
                            display: "flex",
                            flexDirection: "column"
                        }}
                    >
                        <Stepper activeStep={activeStep} alternativeLabel>
                            {steps.map((label, index) => (
                                <Step key={label}>
                                    <StepLabel>{label}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>

                        <Box
                            mt={3}
                            style={{
                                flex: 1,
                                display: "flex",
                                flexDirection: "column",
                                minHeight: 0
                            }}
                        >
                            {getStepContent(activeStep)}
                        </Box>


                        <Box mt={4} display="flex" justifyContent={activeStep !== 0 ? "space-between" : "flex-end"}>
                            {activeStep !== 0 ?
                                <Button
                                    disabled={activeStep === 0}
                                    onClick={handleBack}
                                    variant="contained"
                                >
                                    Anterior
                                </Button>
                                :
                                null
                            }

                            {activeStep === 2 ?
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        setIsLoading(true)
                                        let bodyFormData = new FormData();
                                        bodyFormData.append('file', archivo)
                                        postCargaMasivaEq(bodyFormData)
                                    }}
                                    disabled={archivo ? false : true}
                                >
                                    Cargar planilla
                                </Button>
                                :

                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleNext}
                                    disabled={activeStep === steps.length - 1}
                                >
                                    Siguiente
                                </Button>
                            }
                        </Box>

                    </Paper>
                </Grid>
            </Grid>
        </div>
    );
}